// src/pages/admin/Tags.jsx
import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CrudPage from '../../components/admin/CrudPage';
import { tagAPI } from '../../services/api';

const Form = ({ form, onChange }) => (
  <>
    <div className="form-group">
      <label className="form-label required">Tag Name</label>
      <input className="form-input" name="name" value={form.name || ''} onChange={onChange} placeholder="e.g. Pediatric Safe" required />
    </div>
    <div className="form-group">
      <label className="form-label">Tag Color</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <input
          type="color"
          name="color"
          value={form.color || '#3498db'}
          onChange={onChange}
          style={{ width: 48, height: 40, border: '1px solid var(--gray-200)', borderRadius: 8, padding: 4, cursor: 'pointer' }}
        />
        <input
          className="form-input"
          name="color"
          value={form.color || '#3498db'}
          onChange={onChange}
          placeholder="#3498db"
          style={{ fontFamily: 'var(--font-mono)' }}
        />
      </div>
    </div>
    {form.name && (
      <div>
        <label className="form-label">Preview</label>
        <span
          className="badge"
          style={{ background: (form.color || '#3498db') + '22', color: form.color || '#3498db', border: `1px solid ${form.color || '#3498db'}44` }}
        >
          {form.name}
        </span>
      </div>
    )}
  </>
);

export default function Tags() {
  return (
    <AdminLayout title="Tags">
      <CrudPage
        title="Tags"
        subtitle="Colour-coded tags to label medicines"
        columns={[
          { key: 'id',    label: 'ID' },
          { key: 'name',  label: 'Tag', render: r => (
            <span className="badge" style={{ background: r.color + '22', color: r.color, border: `1px solid ${r.color}44` }}>
              {r.name}
            </span>
          )},
          { key: 'color', label: 'Colour', render: r => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ width: 16, height: 16, borderRadius: 4, background: r.color }} />
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8125rem' }}>{r.color}</span>
            </div>
          )},
        ]}
        fetchFn={tagAPI.getAll}
        createFn={tagAPI.create}
        updateFn={tagAPI.update}
        deleteFn={tagAPI.delete}
        FormComponent={Form}
        formDefault={{ name: '', color: '#3498db' }}
      />
    </AdminLayout>
  );
}
